import React, { useState, useEffect } from 'react';
import { CategoryTab } from './CategoryTab';

export const CategoryTabs = (props) => {
    const [selectedTab, setSelectedTab] = useState(props.listingType);

    useEffect(() => {
        setSelectedTab(props.listingType);
    }, [props.listingType]);

    const handleTabClick = (id) => {
        setSelectedTab(id);
        props.onToggle(id);
    };

    return (
        <div className='container-fluid'>
            <div className='row d-none d-md-block'>
                <div className='col-md-12 text-center'>
                    <ul className="row nav justify-content-center" role="tablist" style={{ backgroundColor: '#e7f3e6' }}>
                        <CategoryTab onClick={handleTabClick} title={'wifi_home'} id={'all'} active={selectedTab === "all"} />
                        <CategoryTab onClick={handleTabClick} title={'video_library'} id="videos" active={selectedTab === "videos"} />
                        <CategoryTab onClick={handleTabClick} title={'autoplay'} id="clips" active={selectedTab === "clips"} />
                        <CategoryTab onClick={handleTabClick} title={'photo_library'} id="photos" active={selectedTab === "photos"} />
                        <CategoryTab onClick={handleTabClick} title={'photo_album'} id="album" active={selectedTab === "album"} />
                        <CategoryTab onClick={handleTabClick} title={'auto_stories'} id="pages" active={selectedTab === "pages"} />
                        <CategoryTab onClick={handleTabClick} title={'hotel_class'} id="reviews" active={selectedTab === "reviews"} />
                    </ul>
                </div>
            </div>

            <div className='row d-block d-md-none mt-2'>
                <div className='col-md-12 text-center'>
                    <ul className="row nav" role="tablist" style={{ backgroundColor: '#e7f3e6' }}>
                        <CategoryTab onClick={handleTabClick} title={'wifi_home'} id={'all'} active={selectedTab === "all"} />
                        <CategoryTab onClick={handleTabClick} title={'video_library'} id="videos" active={selectedTab === "videos"} />
                        <CategoryTab onClick={handleTabClick} title={'autoplay'} id="clips" active={selectedTab === "clips"} />
                        <CategoryTab onClick={handleTabClick} title={'photo_library'} id="photos" active={selectedTab === "photos"} />
                        <CategoryTab onClick={handleTabClick} title={'photo_album'} id="album" active={selectedTab === "album"} />
                        <CategoryTab onClick={handleTabClick} title={'auto_stories'} id="pages" active={selectedTab === "pages"} />
                        <CategoryTab onClick={handleTabClick} title={'hotel_class'} id="reviews" active={selectedTab === "reviews"} />
                    </ul>
                </div>
            </div>
        </div>
    );
};
